module.exports = __webpack_public_path__ + "4b357782daec4239711055c06af93881.png";